import { dataPinSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPinSolid = /*#__PURE__*/createIcon(dataPinSolid)
export default IconPinSolid
